import type { CookieSetOptions } from 'universal-cookie';
import Cookies from 'universal-cookie';

const ONE_DAY_IN_SECONDS = 60 * 60 * 24;
const cookies = new Cookies();

const allowCookiesInIframe: Pick<CookieSetOptions, 'sameSite' | 'secure'> = {
    sameSite: 'none',
    secure: true
};

export const getCookieByKey = (key: string) => cookies.get(key);

export const setCookieByKey = (key: string, value: $TSFixMe): void => {
    cookies.set(key, value, {
        path: '/',
        maxAge: ONE_DAY_IN_SECONDS,
        ...allowCookiesInIframe
    });
};

export const removeCookieByKey = (key: string): void => {
    cookies.remove(key);
};
